<template lang="pug">
  v-card.creating-card.pa-6(flat)
    .text-center
      .creating-card__title ระบบกำลังสร้างช่องทางชำระเงิน กรุณารอสักครู่ ⏳
      .creating-card__hint.mt-3 🙏 กรุณาอย่าปิดหน้านี้จนกว่าบัญชีฝากจะปรากฏ
      .creating-card__warn.mt-1 ระบบอาจใช้เวลา 3-5 นาที ในการสร้างรายการฝาก
      .creating-card__spinner.mt-8
        v-progress-circular(
          indeterminate
          :size='180'
          :width='8'
          color='#4a90e2'
        )
          span.creating-card__spinner-text กำลังสร้าง...
      .creating-card__countdown.mt-8
        v-icon.mr-1(small color='#4a90e2') mdi-clock-outline
        span เวลาที่เหลือ {{ countdownText }}
</template>
<script>
export default {
  props : {
    countdown : {
      type : Number,
      default : 0
    }
  },
  computed : {
    countdownText () {
      const total = Math.max(0, this.countdown)
      const mm = String(Math.floor(total / 60)).padStart(2, '0')
      const ss = String(total % 60).padStart(2, '0')
      return `${mm}:${ss}`
    }
  }
}
</script>
<style scoped>
.creating-card {
  border-radius: 16px;
}

.creating-card__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.6;
}

.creating-card__hint {
  font-size: 0.95rem;
  color: #5f6b7a;
}

.creating-card__warn {
  font-size: 0.9rem;
  color: #e74c3c;
}

.creating-card__spinner-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #4a90e2;
}

.creating-card__countdown {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 999px;
  background: #eef4fd;
  color: #4a90e2;
  font-weight: 600;
  font-size: 0.95rem;
}
</style>
